<template>
  <div class="page">
    <div class="main-container">
      <div class="content">
        <div class="content-topic">
          <el-collapse v-model="activeNames">
            <el-collapse-item title="1.如何签到？" name="1">
              <div class="item-content">
                <p>1）点击签到，每天首次登录系统也会自动弹出签到页面</p>
                <p>
                  2）每天签到获得奖励不等（有机会获得金币、贵族、装扮等精美礼物等奖励），还有砸金蛋、开宝箱随机获得精美奖励哦～</p>
                <p>3）连续签到7天可获得开启宝箱奖励</p>
                <p><span class="blue-text"
                         @click="handleSpanClick('toSign')">温馨提示:同一台设备仅限每日签到一次，超出次数当日不可再次签到。</span>
                </p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="2.金币有什么用？" name="2">
              <div class="item-content">
                <p>1)金币可用来和用户文字、语音和视频聊天，还可以赠送礼物表达心意。</p>
                <p>2)金币不参与兑换，无法兑换积分。</p>
                <p>3)消耗的金币将产生积分，积分则可以兑换成金币、贵族、实物商品和提现。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="3.如何充值金币？" name="3">
              <div class="item-content">
                <p>在软件底部点击【我的】-【充值】-选择相应的金币面值进行充值。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="4.私聊回复了消息，怎么金币还被退回去？" name="4">
              <div class="item-content">
                <p>12小时内回复即可获得相应金币;</p>
                <P>12小时内没有回复消息，金币是系统自动退回到对方的账号</P>
                <p>
                  可以在金币清单核对一下是否收到金币，聊天界面金币系统显示有可能延迟，如果有问题可以提供对方ID号给在线客服处理。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="5.私聊对方主动发消息为什么回复没金币？" name="5">
              <div class="item-content">
                <p>主动发消息方需付金币，对方12小时内回复即可获得相应积分。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="6.金币可以兑换积分吗？" name="6">
              <div class="item-content">
                <p>
                  积分可以兑换成金币、贵族和提现，金币则无法兑换积分，金币可用来和用户文字、语音和视频聊天，还可以赠送礼物表达心意。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="7.金币消费记录如何查看？" name="7">
              <div class="item-content">
                <p>点击<span class="blue-text" @click="handleSpanClick('toGoldBill')">消费记录</span>可查看具体的金币消费记录。
                </p>
                <p>在充值过程中遇到问题，可以反馈给在线客服咨询(服务时间8:00- -17:30)</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="8.互相关注成为好友了为什么发信息还要收取金币？" name="8">
              <div class="item-content">
                <p>互相关注即是好友，成为好友后完成实名认证双方发送信息是免费的；</p>
                <p>
                  互相关注与视频通话收费没有关系，与对方互相成为守护天使且达到LV6永结同心，互相守护后音视频通话是免费的</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="9.开通贵族后聊天为什么还需要金币？" name="9">
              <div class="item-content">
                <p>贵族是陌生约聊帐户的尊贵体现，成为贵族可以享有一定的权益。不同等级的贵族享有不同的权益，您可以点击<span
                  class="blue-text" @click="handleSpanClick('toVip')">贵族</span>查看更详细的贵族权益;</p>
                <p>陌生约聊秉持平台公正公平原则，聊天收费或免费的功能权限完全交由用户自主设置，当对方用户设置聊天需付费时发消息需付金币，
                  对方12小时内不回复则金币退还。加为好友(互相关注且完成实名认证)聊天免费，男女平等;</p>
                <p>付费聊天，可以主动追求你喜欢的人，并得到及时回应，可靠且高效。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="10.什么是贵族？" name="10">
              <div class="item-content">
                <p>1）贵族是爱聊账户的尊贵体现，成为贵族可以享有一定的权益。</p>
                <p>2）贵族包含：骑士、子爵、伯爵、公爵、亲王、帝皇</p>
                <p>3）不同等级的贵族享有不同的权益，详情请点击 贵族中心，查看了解</p>
                <p>4）贵族三个不同有效期：1个月、3个月、12个月</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="11.贵族包月怎么取消？" name="11">
              <div class="item-content">
                <p>您好，贵族暂无自动续费功能。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="12.为什么聊天需要金币？" name="12">
              <div class="item-content">
                <p>
                  陌生约聊作为平台方为有交友需求的用户双方搭建聊天互动的桥梁，秉持平台中立性的原则，聊天免费或收费的功能权限完全交由用户自主设置;</p>
                <p>当对方用户设置聊天需付费时发消息需付金币，
                  对方12小时内不回复则金币退还。付费聊天，可以主动追求你喜欢的人，并得到及时回应，可靠且高效；</p>
                <p>每日签到可免费获得金币，你还可以通过邀请好友赚钱、做任务等方法免费获取金币。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="13.为什么聊天要充值？" name="13">
              <div class="item-content">
                <p>陌生约聊独创了付费聊天模式，聊天免费与付费，完全交由用户自主设置</p>
                <p>
                  当对方用户设置聊天需付费时发消息需付金币，对方12小时内不回复退还金币。对方用户设置免费时，发消息免费。</p>
                <p>聊天付费，可以主动追求你喜欢的人，并得到及时回应；还能过滤骚扰、验证诚意，可靠又高效;</p>
                <p>金币也不是必须充值，可通过做签到、做任务等方法免费获取金币。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="14.搭讪需要花费金币吗？" name="14">
              <div class="item-content">
                <p>1)搭讪是根据搜索条件、交友需求账号活跃、违规频次，聊天质量等相关信息进行智能化推荐匹配。</p>
                <p>2)建议您可以主动一对一聊天提高聊天质量的，或者也可以在首页或者广场多互动。</p>
                <p>3)每次搭讪需要消耗1金币。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="15.充值方式有以下几种？" name="15">
              <div class="item-content">
                <p>在软件底部点击【我】-【充值】-选择相应的金币面值进行充值，可以使用支付宝或微信进行充值。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="16.如何查看账号金币？" name="16" class="last">
              <div class="item-content">
                <p>点击我的-充值界面即可查看您当前所有金币，在充值过程中遇到问题，请联系官方在线客服，快速解决问题。</p>
              </div>
            </el-collapse-item>

          </el-collapse>
        </div>
      </div>
    </div>
    <Service/>
  </div>
</template>

<script>
import Service from "./Service";

export default {
  name: 'Index',
  components: {Service},

  data() {
    return {
      activeNames: '',
    }
  },
  methods: {
    goAddPage(route) {
      this.$router.push(route);
    },
    handleSpanClick(value) {
      var basePath = "<%=basePath%>";
      var browser = {
        versions: function () {
          var u = navigator.userAgent, app = navigator.appVersion;
          return {//移动终端浏览器版本信息
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
          };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
      };

      // 调用浏览器版本信息判断是IOS还是Android
      if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
        window.webkit.messageHandlers.WebToiOS.postMessage(value);
      } else {
        this.showInfoFromJs(value);
      }
    },
    showInfoFromJs(value) {
      return window.AndroidWebView.showInfoFromJs(value);
    },
  }
}
</script>

<style scoped>

.icon-top {
  width: 100%;
  height: 143px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.icon-item {
  width: 80px;
  height: 102px;
  border-radius: 8px;
}

.hr {
  height: 12px;
  width: 100%;
  background: #F9FAFC;
}

.content {
  width: 100%;
}

.content-title {
  margin-top: 20px;
  margin-left: 12px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
}


/deep/ .van-cell {
  color: #666666;
}

/deep/ .van-icon-circle2 {
  color: #3576F9;
}

/deep/ .van-icon-circle {
  color: #E6E5E5;
}

/deep/ .checked-title {
  font-size: 15px;
  color: #000000 !important;
}

/deep/ .unchecked {
  font-size: 15px;
}

.item-content {
  font-size: 13px;
  color: #333333;
  line-height: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.item-title {
  font-weight: 600;
}

.key-text {
  font-weight: 500;
  color: #4C30FC;
}

.item-img {
  width: 100%;
  text-align: center;
  margin-top: 30px;
}

.customer-service {
  position: fixed;
  bottom: 30px;
  left: 80%;
  transform: translateX(-50%);
  width: 60px;
  height: 60px;
}

.customer-service img {
  width: 100%;
  height: 100%;
}

.collapse {
  background-color: transparent;
}

.red-text {
  color: red;
}

.blue-text {
  color: cornflowerblue;
}

.main-container {
  z-index: 999;
  position: relative;
  background-color: #f5f7fb;
  padding: 18px 18px 14px 18px;
}

.content .content-topic:last-child {
  margin-bottom: 70px;
}

.content-topic {
  padding: 0 13px;
  background-color: #ffffff;
  border-radius: 10px;
}

.content-topic .el-collapse {
  border-top: none;
  border-bottom: none;
}

.content-topic .el-collapse-item__header {
  font-size: 15px;
}

.content-topic .last .el-collapse-item__header {
  border-bottom: none;
}
</style>




// WEBPACK FOOTER //
// src/page/Money.vue